// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-139670b4] .mobile-menu-trigger {
  padding-left: 10px;
  margin-bottom: 8px;
}
.page-wrapper[data-v-139670b4] {
  height: 100%;
}
.page-wrapper-content[data-v-139670b4] {
  height: 100%;
  padding-top: var(--139670b4-\\\$getStyles\\.contentPaddingTop);
  padding-bottom: var(--139670b4-\\\$getStyles\\.contentPaddingBottom);
  padding-left: var(--139670b4-\\\$getStyles\\.contentPaddingLeft);
  padding-right: var(--139670b4-\\\$getStyles\\.contentPaddingRight);
}
.nav-container[data-v-139670b4] {
  position: sticky;
  top: 0;
  z-index: 2;
  margin-inline: auto;
}
@media (max-width: 1365px) {
.hamburger[data-v-139670b4] {
    display: none;
}
}
@media (min-width: 1366px) {
.hamburger[data-v-139670b4] {
    display: none;
}
}
.side-navigation[data-v-139670b4] {
  padding-top: 0;
  padding-left: 20px;
}
.side-navigation[data-v-139670b4] .vertical {
  width: 100%;
}
@media (max-width: 768px) {
.side-navigation[data-v-139670b4] {
    position: absolute;
    z-index: 3;
    border-radius: 8px;
    padding-left: 10px;
}
}
.site-content[data-v-139670b4] {
  max-height: calc(100vh - 80px);
  margin-inline: auto;
}
@media (max-width: 768px) {
.site-content[data-v-139670b4] {
    position: relative;
}
}
[data-v-139670b4] .reactive-width.col.width-fixed {
  min-width: unset;
}
[data-v-139670b4] .side-navigation .menu-item.active {
  background-color: var(--139670b4-\\\$getStyles\\.selectedItemBackgroundColor) !important;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/PageWrapper.vue","webpack://./PageWrapper.vue","webpack://./src/Web/scripts/styles/breakpoint-mixin.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kBAAA;ACDF;ADIA;EACE,YAAA;ACDF;ADGE;EACE,YAAA;EAEA,2DAAA;EACA,iEAAA;EACA,6DAAA;EACA,+DAAA;ACFJ;ADMA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EAEA,mBAAA;ACJF;ACdE;AFqBF;IAEI,aAAA;ACJF;AACF;ACdE;AFeF;IAMI,aAAA;ACHF;AACF;ADMA;EACE,cAAA;EACA,kBAAA;ACHF;ADKE;EACE,WAAA;ACHJ;ACvCE;AFqCF;IASI,kBAAA;IACA,UAAA;IAEA,kBAAA;IACA,kBAAA;ACJF;AACF;ADOA;EACE,8BAAA;EAEA,mBAAA;ACLF;ACpDE;AFsDF;IAMI,kBAAA;ACJF;AACF;ADOA;EACE,gBAAA;ACJF;ADOA;EACE,qFAAA;ACJF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.mobile-menu-trigger) {\n  padding-left: 10px;\n  margin-bottom: 8px;\n}\n\n.page-wrapper {\n  height: 100%;\n\n  &-content {\n    height: 100%;\n\n    padding-top: v-bind(\"$getStyles.contentPaddingTop\");\n    padding-bottom: v-bind(\"$getStyles.contentPaddingBottom\");\n    padding-left: v-bind(\"$getStyles.contentPaddingLeft\");\n    padding-right: v-bind(\"$getStyles.contentPaddingRight\");\n  }\n}\n\n.nav-container {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  //max-width: 1515px;\n  margin-inline: auto;\n}\n\n.hamburger {\n  @include tablet {\n    display: none;\n  }\n\n  @include desktop {\n    display: none;\n  }\n}\n\n.side-navigation {\n  padding-top: 0;\n  padding-left: 20px;\n\n  :deep(.vertical){\n    width: 100%;\n  }\n\n  @include phone {\n    position: absolute;\n    z-index: 3;\n    //border: #e7e5eb 1px solid;\n    border-radius: 8px;\n    padding-left: 10px;\n  }\n}\n\n.site-content {\n  max-height: calc(100vh - 80px); // fill all available space after nav\n  //max-width: 1515px;\n  margin-inline: auto;\n\n  @include phone {\n    position: relative;\n  }\n}\n\n:deep(.reactive-width.col.width-fixed) {\n  min-width: unset;\n}\n\n:deep(.side-navigation .menu-item.active) {\n  background-color: v-bind(\"$getStyles.selectedItemBackgroundColor\") !important;\n}\n",":deep(.mobile-menu-trigger) {\n  padding-left: 10px;\n  margin-bottom: 8px;\n}\n\n.page-wrapper {\n  height: 100%;\n}\n.page-wrapper-content {\n  height: 100%;\n  padding-top: v-bind(\"$getStyles.contentPaddingTop\");\n  padding-bottom: v-bind(\"$getStyles.contentPaddingBottom\");\n  padding-left: v-bind(\"$getStyles.contentPaddingLeft\");\n  padding-right: v-bind(\"$getStyles.contentPaddingRight\");\n}\n\n.nav-container {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  margin-inline: auto;\n}\n\n@media (max-width: 1365px) {\n  .hamburger {\n    display: none;\n  }\n}\n@media (min-width: 1366px) {\n  .hamburger {\n    display: none;\n  }\n}\n\n.side-navigation {\n  padding-top: 0;\n  padding-left: 20px;\n}\n.side-navigation :deep(.vertical) {\n  width: 100%;\n}\n@media (max-width: 768px) {\n  .side-navigation {\n    position: absolute;\n    z-index: 3;\n    border-radius: 8px;\n    padding-left: 10px;\n  }\n}\n\n.site-content {\n  max-height: calc(100vh - 80px);\n  margin-inline: auto;\n}\n@media (max-width: 768px) {\n  .site-content {\n    position: relative;\n  }\n}\n\n:deep(.reactive-width.col.width-fixed) {\n  min-width: unset;\n}\n\n:deep(.side-navigation .menu-item.active) {\n  background-color: v-bind(\"$getStyles.selectedItemBackgroundColor\") !important;\n}","@mixin phone {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media (max-width: 1365px) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: 1366px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
